<div class="widget-place-holder-background bg-subtle-color" [ngClass]="useGhostContent ? 'transparent': ''">
    <ng-content></ng-content>
</div>
